import script from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./conferenceDetailPage.vue?vue&type=style&index=0&id=8efe0b5c&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8efe0b5c"]])

export default __exports__